const getClientId = config => {
  let clientId;
  clientId = config?.vInitRequest?.clientId ?? null;
  if (!clientId) {
    clientId = config?.merchantConfig?.clientId ?? null;
  }
  if (!clientId) {
    clientId = config?.merchantConfig?.srcDpaId ?? null;
  }
  return clientId;
};

export default getClientId;
